import { Routes, Route, Navigate } from "react-router-dom";
import AddFaq from "../Pages/AddFaq/AddFaq";
import ListFaqs from "../Pages/AddFaq/ListFaqs";
import EditFaq from "../Pages/AddFaq/EditFaq";
import AddBlog from "../Pages/AddBlog/AddBlog";
import ListBlogs from "../Pages/AddBlog/ListBlogs";
import EditBlog from "../Pages/AddBlog/EditBlog";
import { ProtectedRoute } from "../ProtectedRoute";
import ContactList from "../Pages/Contact List/ContactList";
import AddBlogCategory from "../Pages/AddBlog/AddCategory";
import AddEvent from "../Pages/Events/AddEvent";
import ListEvents from "../Pages/Events/ListEvents";
import EditEvent from "../Pages/Events/EditEvent";
import AddEventCategory from "../Pages/Events/AddCategory";
import AddTour from "../Pages/AddTour/AddTour";
import AddCountry from "../Pages/Country/AddCountry";
import AddState from "../Pages/Country/AddState";
import AddDestination from "../Pages/Destination/AddDestination";
import ListDestinations from "../Pages/Destination/ListDestination";
import EditDestination from "../Pages/Destination/EditDestination";
import ListTours from "../Pages/AddTour/ListTours";
import EditTour from "../Pages/AddTour/EditTour";
import AddGallery from "../Pages/Country/AddGallry";
import AddTeamMembers from "../Pages/AddTeamMembers/AddTeamMembers";
import ListTeamMembersTable from "../Pages/AddTeamMembers/LIstTeam";
import EditTeamMembers from "../Pages/AddTeamMembers/EditTeam";
import AddTracking from "../Pages/AddTracking/AddTracking";
import ListTracking from "../Pages/AddTracking/TrackingList";
import EditTracking from "../Pages/AddTracking/EditTracking";
import SEOSettings from "../Pages/SEOSettings/SEOSettings";

function AppRoutes() {
  return (
    <Routes>
      {/* <Route path="/" element={<Login />} /> */}

      <Route element={<ProtectedRoute />}>
        <Route path="/AddFaq" element={<AddFaq />} />
        <Route path="/edit-faq/:id" element={<EditFaq />} />
        <Route path="/listfaq" element={<ListFaqs />} />
        <Route path="/addblog" element={<AddBlog />} />
        <Route path="/edit-blog/:id" element={<EditBlog />} />
        <Route path="/addblog-category" element={<AddBlogCategory />} />
        <Route path="/listblogs" element={<ListBlogs />} />
        <Route path="/contact" element={<ContactList />} />
        <Route path="/add-event" element={<AddEvent />} />
        <Route path="/add-tour" element={<AddTour />} />
        <Route path="/add-tracking" element={<AddTracking />} />
        <Route path="/edit-tour/:id" element={<EditTour />} />
        <Route path="/list-tours" element={<ListTours />} />
        <Route path="/tracking-list" element={<ListTracking />} />
        <Route path="/edit-tracking/:id" element={<EditTracking />} />
        <Route path="/edit-event/:id" element={<EditEvent />} />
        <Route path="/event-list" element={<ListEvents />} />
        <Route path="/addevent-category" element={<AddEventCategory />} />
        <Route path="/add-country" element={<AddCountry />} />
        <Route path="/add-state" element={<AddState />} />
        <Route path="/add-destination" element={<AddDestination />} />
        <Route path="/destination-list" element={<ListDestinations />} />
        <Route path="/edit-destination/:id" element={<EditDestination />} />
        <Route path="/add-gallery" element={<AddGallery />} />
        <Route path="/add-team-members" element={<AddTeamMembers />} />
        <Route path="/edit-team-members/:id" element={<EditTeamMembers />} />
        <Route path="/list-team-members" element={<ListTeamMembersTable />} />
        <Route path="/seo-settings" element={<SEOSettings />} />

        <Route path="*" element={<Navigate to="/contact" replace />} />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
